import React, { createContext, PropsWithChildren, useContext, useState } from 'react';

interface CallToBookProps {
  showPhoneNumber: boolean;
  setShowPhoneNumber: (update: boolean) => void;
}

export const CallToBookContext = createContext<null | CallToBookProps>(null);

export function CallToBookProvider({ children }: PropsWithChildren) {
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  return (
    <CallToBookContext.Provider
      value={{
        showPhoneNumber,
        setShowPhoneNumber,
      }}
    >
      {children}
    </CallToBookContext.Provider>
  );
}

export const useCallToBookContext = () => {
  const callToBookData = useContext(CallToBookContext);

  return callToBookData;
};
